import { render, staticRenderFns } from "./GardenerCustomerFeedback.vue?vue&type=template&id=13456e7f"
import script from "./GardenerCustomerFeedback.vue?vue&type=script&lang=js"
export * from "./GardenerCustomerFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports